import React from "react";
import preview from "../../../assets/portfolio/dealeralchemist/preview.png";

export default function DealerAlchemist() {
	return (
		<div
			style={{ margin: "0 2rem", width: "calc(50% - 4rem)" }}
			data-aos="fade-up">
			<h2
				style={{
					fontWeight: 400,
					fontSize: "16px",
					lineHeight: "16px",
					margin: "1rem 0",
				}}>
				Dealer Alchemist{" "}
			</h2>
			<h3>Custom React Analytics Interface</h3>
			<p>Custom analytics dashboard for tracking and reporting.</p>
			<div
				style={{
					width: "100%",
					height: "600px",
					overflow: "hidden",
					borderRadius: "10px",
					paddingLeft: "2rem",
					paddingTop: "2rem",
					backgroundColor: "#5D87FF",
				}}>
				<img
					src={preview}
					alt="Dealer Alchemist Custom React Analytics Interface"
					style={{ height: "100%" }}
				/>
			</div>
		</div>
	);
}
